module.exports = __webpack_public_path__ + "img/3.94b1c370.jpg";